<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-one">
<h1>Chapter One</h1>
<p>“Darlington! Pay attention, lad!”</p>
<p>With remarkable speed, the chalk flew through the packed, stuffy classroom, narrowly missing the boy’s temple, making his astute eyes lift and stare unblinkingly at the object of his scorn. <em>I hate him.</em> He snapped his eyes shut. <em>I fucking hate, hate, HATE—the fucking bastard!</em> Opening his vengeful eyes, he aimed to outstare his persecutor; too late, Mister Sugden had moved on to another unsuspecting victim, leaving Joshua to stew in his cauldron of bitter-raw misery, where oppressive thoughts and hopeless, despairing emotions whirled and swirled; bubbled and frothed, threatening to pull him further, further, further down into a dark and dismal well of no return, in which he could feel and think no more.</p>
<p>A sudden tug on his arm immediately brought him back to the present, his eyes darting to his best friend, taking him in as if he were some stranger, before switching his gaze to the rapid exodus at the door where his classmates were eagerly filing out of the room.</p>
<p>“You were away with the fairies, mate,” smirked Mick, giving him a friendly swipe on the shoulder. “Come on; it’s home time.”</p>
<p>As the two teenagers gathered their protractors, rulers, exercise, and textbooks, Joshua was feeling short-changed; maths was his favourite subject, and he’d wasted three-quarters of the lesson plotting untold revenge on his teacher.</p>
<p>Walking the half-kilometre home, he tried furiously to reign in his swirly thoughts, and gradually, very slowly, a picture of his younger self began to emerge out of the fragmented puzzle and rise above the ashes of his despondency; a reflection of a young boy, five or six years of age; a happy, carefree boy; an innocent who had everything: a loving mother and father, a comfortable home, food, toys, and all the love and joys of a happy, loving family. And then…</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?6a7cdccf